export default function IconBookLibrary({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.53 0.53 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5.30961 1.0918H3.20086C2.14648 1.0918 2.14648 2.14617 2.14648 2.14617V12.1627C2.14648 13.2171 3.20086 13.2171 3.20086 13.2171H5.30961C6.36398 13.2171 6.36398 12.1627 6.36398 12.1627V2.14617C6.36398 1.0918 5.30961 1.0918 5.30961 1.0918Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.52738 1.0918H7.41863C6.36426 1.0918 6.36426 2.14617 6.36426 2.14617V12.1627C6.36426 13.2171 7.41863 13.2171 7.41863 13.2171H9.52738C10.5818 13.2171 10.5818 12.1627 10.5818 12.1627V2.14617C10.5818 1.0918 9.52738 1.0918 9.52738 1.0918Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1968 2.11023L12.1534 2.26183C11.11 2.41343 11.2616 3.45685 11.2616 3.45685L12.5502 12.3259C12.7018 13.3693 13.7453 13.2177 13.7453 13.2177L14.7887 13.0661C15.8321 12.9145 15.6805 11.8711 15.6805 11.8711L14.3918 3.00204C14.2402 1.95862 13.1968 2.11023 13.1968 2.11023Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.0918 14.2721C1.0918 14.4106 1.11907 14.5477 1.17206 14.6756C1.22504 14.8036 1.30271 14.9198 1.40062 15.0177C1.49852 15.1156 1.61476 15.1933 1.74268 15.2463C1.8706 15.2993 2.00771 15.3265 2.14617 15.3265H15.853C16.1327 15.3265 16.4009 15.2154 16.5986 15.0177C16.7963 14.82 16.9074 14.5518 16.9074 14.2721C16.9074 13.9925 16.7963 13.7243 16.5986 13.5266C16.4009 13.3289 16.1327 13.2178 15.853 13.2178H2.14617C1.86653 13.2178 1.59835 13.3289 1.40062 13.5266C1.20288 13.7243 1.0918 13.9925 1.0918 14.2721Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.67383 15.3262V16.9077"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3262 15.3262V16.9077"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
